import {
  Block,
  ModalBody,
  ModalFooter,
  ParagraphMedium,
  useStyletron,
} from "@mezo-org/mezo-clay"

import { StepperModalButton } from "../StepperModal"
import { ComponentStepProps } from "../StepperModal/StepperModal"

import BridgeSummaryList from "./BridgeSummaryList"
import SendFromAnotherWalletListItem from "./SendFromAnotherWalletListItem"

export default function AddFundsStep({ onClickContinue }: ComponentStepProps) {
  const [css, theme] = useStyletron()

  // TODO: Temporary solution
  const summary = [
    {
      label: "Transfer Time",
      endEnhancer: "~3 mins",
    },
    {
      label: "Via",
      endEnhancer: "Native Bridge",
    },
    {
      label: "Network fees",
      endEnhancer: "0.0001066 ETH ($2.89)",
    },
  ]

  return (
    <>
      <ModalBody
        className={css({
          height: "100%",
          display: "flex",
          flexDirection: "column",
          gap: theme.sizing.scale100,
        })}
      >
        <Block
          as="ul"
          className={css({
            listStylePosition: "inside",
          })}
        >
          <ParagraphMedium as="li">
            Add funds only support Ethereum wallets.
          </ParagraphMedium>
          <ParagraphMedium as="li" marginBottom={theme.sizing.scale1000}>
            Bridging funds is a one-way transaction that’s non-reversible.
          </ParagraphMedium>
          <SendFromAnotherWalletListItem />
        </Block>
        <BridgeSummaryList list={summary} />
      </ModalBody>
      <ModalFooter>
        <StepperModalButton onClick={onClickContinue}>
          Review
        </StepperModalButton>
      </ModalFooter>
    </>
  )
}
